var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_1410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 20.7945C3.5625 21.4575 4.10491 21.9999 4.76786 21.9999H19.2322C19.8952 21.9999 20.4376 21.4575 20.4376 20.7945C20.4376 20.1316 19.8952 19.5892 19.2322 19.5892H4.76786C4.10491 19.5892 3.5625 20.1316 3.5625 20.7945Z",
    fill: "#002466"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.99951C12.15 1.99951 12.2958 2.03285 12.4375 2.09951C12.5792 2.16618 12.7 2.26618 12.8 2.39951L17.75 8.74951C18 9.08285 18.0333 9.43701 17.85 9.81201C17.6667 10.187 17.3667 10.3745 16.95 10.3745H15V16.3745C15 16.6578 14.9042 16.8953 14.7125 17.087C14.5208 17.2787 14.2833 17.3745 14 17.3745H9.99999C9.71666 17.3745 9.47916 17.2787 9.28749 17.087C9.09583 16.8953 8.99999 16.6578 8.99999 16.3745V10.3745H7.04999C6.63332 10.3745 6.33332 10.187 6.14999 9.81201C5.96666 9.43701 5.99999 9.08285 6.24999 8.74951L11.2 2.39951C11.3 2.26618 11.4208 2.16618 11.5625 2.09951C11.7042 2.03285 11.85 1.99951 12 1.99951Z",
    fill: "#002466"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_1410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadInactive);
export default __webpack_public_path__ + "static/media/upload-inactive.19638e5b3d0c8773624a3f35410391cf.svg";
export { ForwardRef as ReactComponent };